// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!./ComboboxListTokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable property-disallowed-list -- DS component definition */

.ComboboxList-module__Container__L567K {
    z-index: var(--ds-combobox-list-z-index);
    max-height: 0;
    overflow: hidden;
    background: transparent;
    border: 0;
    transition:
        max-height var(--ds-transition-s),
        display var(--ds-transition-s) ease-in-out allow-discrete;
}

.ComboboxList-module__ListSizeM__wNg3t:popover-open {
    max-height: var(--ds-48x);
    /* Guarantee end state for collapse transition (animation) */
    @starting-style {
        max-height: 0;
    }
}

.ComboboxList-module__Listbox__G8lbo {
    display: flex;
    flex-direction: column;
    gap: var(--ds-xs);
    width: 100%;
    max-height: inherit;
    padding: var(--ds-s);
    overflow: auto;
    background-color: var(--ds-combobox-list-bg-color);
    border: 1px solid var(--ds-combobox-list-border-color);
    border-radius: var(--ds-border-radius-sm);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `ComboboxList-module__Container__L567K`,
	"ListSizeM": `ComboboxList-module__ListSizeM__wNg3t`,
	"Listbox": `ComboboxList-module__Listbox__G8lbo`
};
export default ___CSS_LOADER_EXPORT___;
